import React from 'react'
import { localsMessages } from '../utility/getTemplateData'

let messages = localsMessages('common/guestTerms')

class GuestTerms extends React.Component {

	createMarkup() {
		return { __html: messages.terms };
	}

	render () {
		return (
			<div className="vx_text-legal text-center"
				style={{ margin: '20px auto', fontFamily: 'pp-sans-big-regular' }}
				dangerouslySetInnerHTML={this.createMarkup()}>
			</div>
		);
	}
}

export default GuestTerms



// WEBPACK FOOTER //
// ./components/guestTerms.js